import { IAppState } from '../../../AppModulesWrapper';

import { selectIsPromotionForbidden, selectIsServicesEnabled, selectIsWithoutTopAndPremium } from '../publishTerms';

export const selectIsModuleWithPromotion = (state: IAppState): boolean => {
  const isPromotionForbidden = selectIsPromotionForbidden(state);
  const isWithoutTopAndPremium = selectIsWithoutTopAndPremium(state);
  const isDisabledPromotion = isPromotionForbidden || isWithoutTopAndPremium;

  const isServicesEnabled = selectIsServicesEnabled(state);

  return isDisabledPromotion ? false : isServicesEnabled;
};
